/* eslint-disable security/detect-object-injection */
/* eslint-disable no-secrets/no-secrets */
import React, { useCallback,useState } from 'react';
import _ from 'lodash';
import appConfig from 'app-config';
import { messages } from 'gw-capability-policychange-common-react';
import { useAuthentication } from '@xengage/gw-digital-auth-react';
import { useDependencies } from '@xengage/gw-portals-dependency-react';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { useTranslator } from '@jutro/locale';
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import { WizardPage, wizardProps } from '@xengage/gw-portals-wizard-react';
import { PremierConstants } from 'premier-constant-service';
import { useSkipStep, useContactPhoneUtil } from 'premier-capability-hooks';
import { AdditionalInterestComponent } from 'premier-capability-policyjob-react';
import wizardConfig from "premier-capability-policychange-premierRV-react/config/PremierRV-policychange-wizard-config.json5";
import presentationMetadata from './PolicyChangesPage.metadata.json5';
import styles from './PolicyChangesPage.module.scss';
import './PolicyChangesPage.messages';

function PolicyChangesPage(props) {

    const { updateWizardData, 
        wizardData: policyChangeVM, 
        currentStep,
        steps} = props;

     //   const { stepsOn } = wizardConfig;    
    // const { steps } = wizardConfig['PolicyChange.rv.default.wizard'];
    const { steps:constantSteps } = wizardConfig;
    const [isLocationChecked, setIsLocationChecked] = useState(false);
    const [isDriversChecked, setIsDriversChecked] = useState(false);
    const [isVehiclesChecked, setIsVehiclesChecked] = useState(false);
    const { 
        stepProps: {
            displayAddressFields = false
        }
    } = currentStep;
    const { pageKey } = currentStep;
    const metadata = presentationMetadata[pageKey];
    const { authHeader } = useAuthentication();
    const { EndorsementService } = useDependencies('EndorsementService');
    const {
        isComponentValid,
        onValidate,
        registerInitialComponentValidation
    } = useValidation('PolicyChangesPage');

    useSkipStep(registerInitialComponentValidation, policyChangeVM);
    
    const { lobKeys } = PremierConstants;
    const translator = useTranslator();
    const isRV = _.get(policyChangeVM, 'baseData.productCode.value') === lobKeys.recVehProduct;

    useContactPhoneUtil(policyChangeVM);

    const selectLocation = useCallback(() => {
        setIsLocationChecked(!isLocationChecked);
        updateWizardData(policyChangeVM);
    }, [isLocationChecked, policyChangeVM, updateWizardData]);

    const selectDrivers = useCallback(() => {
        setIsDriversChecked(!isDriversChecked);
        updateWizardData(policyChangeVM);
    }, [isDriversChecked, policyChangeVM, updateWizardData]);

    const selectVehicles = useCallback(() => {
        setIsVehiclesChecked(!isVehiclesChecked);
        updateWizardData(policyChangeVM);
    }, [isVehiclesChecked, policyChangeVM, updateWizardData]); 


    const restructureSteps = useCallback(() => {
        
        const { changeNextSteps, currentStepIndex } = props;
        const newSteps = constantSteps.slice(currentStepIndex + 1, constantSteps.length);

        changeNextSteps(newSteps);
    }, [constantSteps, props]);

    const getAssociationCodes = ()=>{
        if(_.get(policyChangeVM, 'lobData.recVehLine.selectedOffering_Ext.value') === 'MotCyc'){
        return policyChangeVM.baseData.memberOfAssociationClubMC_Ext.aspects.availableValues.map((key) => ({
                code: key.code,
                    name: translator({
                        id: key.name,
                        defaultMessage: key.name
                    })
            }));
    }

        return policyChangeVM.baseData.memberOfAssociationClubOffRoad_Ext.aspects.availableValues.map((key) => ({
                code: key.code,
                    name: translator({
                        id: key.name,
                        defaultMessage: key.name
                    })
            }));
    
    }
   
    const getOfferingType = ()=>policyChangeVM.lobData.recVehLine.offerings_Ext?.value.filter(e=>e.branchCode===policyChangeVM.lobData.recVehLine.selectedOffering_Ext?.value)[0]?.branchName

    const onNext = useCallback(async () => {
         restructureSteps();
        _.set(policyChangeVM, 'baseData.isTransactionSaved_Ext.value', true );
       
        policyChangeVM.value = await EndorsementService.saveEndorsement(
            [policyChangeVM.value],
            authHeader
        );
       
        return policyChangeVM;
                
    }, [restructureSteps, policyChangeVM, EndorsementService, authHeader]);

    const overrideProps = {
        '@field': {
            showRequired: true,
            labelPosition: 'left',
            phoneWide: {
                labelPosition: 'top'
            }
        },
        separator1: {
            visible: !isRV
        },
        changeDescription: {
            className: isRV ? styles.coverage : null
        },
        additionalInterest: {
            value: policyChangeVM,
            path: 'baseData.additionalNamedInsureds_Ext',
            type: 'additionalInsured',
            onValueChange: updateWizardData,
            authHeader
        },
        effectiveDate: {
            minDate: _.get(policyChangeVM, 'baseData.minimumEffectiveDate.value'),
            maxDate: _.get(policyChangeVM, 'baseData.periodEndDate.value'),
           // disabled: _.get(policyChangeVM, 'baseData.isTransactionSaved_Ext.value')
        },
        addressContainer: {
            visible: displayAddressFields
        },
        baseState: {
            visible: false
        },
        reasonForCancellation: {
            visible: _.get(policyChangeVM, 'baseData.hasCancelledByInsCompany_Ext.value')
        },
        ownership: {
            visible: _.get(policyChangeVM, 'lobData.recVehLine.selectedOffering_Ext.value') === "MotCyc"
        },
        memberOfAssociationOrClub: {
            visible: _.get(policyChangeVM, 'lobData.recVehLine.selectedOffering_Ext.value') === "MotCyc" ||  _.get(policyChangeVM, 'lobData.recVehLine.selectedOffering_Ext.value') === "OffRoaVeh",
            path: _.get(policyChangeVM, 'lobData.recVehLine.selectedOffering_Ext.value') === "MotCyc" ? 'baseData.memberOfAssociationClubMC_Ext':'baseData.memberOfAssociationClubOffRoad_Ext',
            availableValues:getAssociationCodes()
        },
        existingPolicyNum:{
            visible:_.get(policyChangeVM, 'lobData.recVehLine.selectedOffering_Ext.value') === "OffRoaVeh"
        },
        businessName: {
            visible: _.get(policyChangeVM, 'lobData.recVehLine.selectedOffering_Ext.value') === "MotCyc"
        },
        cancelledByInsuranceCompany:{
            required:_.get(policyChangeVM, 'lobData.recVehLine.selectedOffering_Ext.value') === "MotCyc"
        },
        offeringType:{
           value:getOfferingType()
        },
        locationCheckbox: {
            value: isLocationChecked,
            onValueChange: selectLocation
       },
       driverCheckbox: {
        value: isDriversChecked,
        onValueChange: selectDrivers
       },
       vehicleCheckbox: {
        value: isVehiclesChecked,
        onValueChange: selectVehicles
       }
    };

    const resolvers = {
        resolveClassNameMap: styles,
        resolveCallbackMap: {
            onValidate
        },
        resolveComponentMap: {
            additionalInterestComponent: AdditionalInterestComponent,
        }
    };

    const cancelLabel = appConfig.persona === 'policyholder' ? messages.cancelAllChanges : messages.cancel;

    const shouldPageSkip = useCallback(() => {
        const status = _.get(policyChangeVM, 'baseData.periodStatus.value.code');

        return status === 'Quoted';
    }, [policyChangeVM]);

    return (
        <WizardPage
            onNext={onNext}
            skipWhen={shouldPageSkip}
            disableNext={!isComponentValid } // || checkForMobileOrHomePhoneForContact()}
            showPrevious={false}
            cancelLabel={cancelLabel}
        >
            <ViewModelForm
                uiProps={metadata.content}
                model={policyChangeVM}
                overrideProps={overrideProps}
                onModelChange={updateWizardData}
                onValidationChange={onValidate}
                classNameMap={resolvers.resolveClassNameMap}
                callbackMap={resolvers.resolveCallbackMap}
                componentMap={resolvers.resolveComponentMap}
            />
        </WizardPage>
    );
}

PolicyChangesPage.propTypes = wizardProps;
export default PolicyChangesPage;